import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-management-configuration',
  templateUrl: './management-configuration.component.html',
  styleUrls: ['./management-configuration.component.scss']
})
export class ManagementConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
